import { Component, inject } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { BaseListComponent } from './base-list.component';

@Component({
  selector: 'app-paginator',
  template: `
    <mat-paginator
      #paginator
      (page)="list.page.number = paginator.pageIndex; list.page.search()"
      [length]="list.page.totalElements"
      [pageIndex]="list.page.number"
      [pageSize]="list.page.size"
      hidePageSize
      showFirstLastButtons
    ></mat-paginator>
  `,
  imports: [MatPaginatorModule],
})
export class BaseListPaginatorComponent {
  list = inject<BaseListComponent<any, any>>(BaseListComponent);
}
